module.exports = __webpack_public_path__ + "static/media/ic-filter.bad2e40d.svg";